module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/iphone-x-83bf79ff7716f01b3bb0d973effb220c.svg";